// extracted by mini-css-extract-plugin
module.exports = {"block":"CodeBlock-styles-module--block--3xEd5 prism-module--prism--2-Zwl"};